import { utils } from "ethers";

export const shortenAddress = (address: string): string => {
  return `${address.substr(0, 6)}...${address.substr(address.length - 4, 4)}`;
};

export const toUnpaddedHexString = (
  chainId: string | number | bigint | utils.Bytes | utils.Hexable
): string => {
  return utils.hexValue(chainId);
};
